import React, { createContext, useState, useContext, useEffect } from 'react';
import { getHelpRequestsCount, checkUser } from '../../data/dataApi';

const UserStateContext = createContext();

export const UserStateProvider = ({ children }) => {
  const [theme, setTheme] = useState();
  const [userRole, setUserRole] = useState();
  const [userId, setUserId] = useState(null);
  const [helpRequests, setHelpRequests] = useState(0);
  const [loggedIn, setLoggedIn] = useState(false);
  const [userCapabilities, setUserCapabilities] = useState([]);

  useEffect(() => {
    (async () => {
      const response = await getHelpRequestsCount();
      const userResponse = await checkUser();

      setTheme(userResponse.theme);
      setUserId(userResponse.id);
      setUserRole(userResponse.role);
      setUserCapabilities(userResponse.capabilities || []);

      if (response.success) {
        setHelpRequests(response.data.rows[0].total_count);
      }
    })();
  }, [loggedIn]);

  return (
    <UserStateContext.Provider value={{ theme, setTheme, userId, setUserId, userRole, helpRequests, setLoggedIn, setHelpRequests, userCapabilities }}>
      { (!loggedIn || userId) && children }
    </UserStateContext.Provider>
  );
};

export const useUserState = () => {
  const context = useContext(UserStateContext);
  if (!context) {
    throw new Error('useUserState must be used within a UserStateProvider');
  }
  return context;
};